import React, { useState } from 'react';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import Title from './Title';
import PriceSection from './PriceSection';
import Button from './Button';
import FeaturesSections from './FeaturesSections';
import Highlighted from './highlighted';
import { fontBodyMini } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import AnchorLink from './AnchorLink';

const Offer = ({
  children,
  swippable,
}: {
  children: React.ReactNode;
  swippable: boolean;
}) => {
  const [isDragging, setIsDragging] = useState(false);
  return (
    <div
      className={classNames(
        'Offer relative',
        'w-[calc(100vw-40px)] sm:w-[400px]',
        'rounded-[18px] p-[24px]',
        'border border-solid border-[#EBF0F5]',
        'h-full gap-[24px]',
        swippable && isDragging && 'cursor-grabbing',
        swippable && 'cursor-grab',
        fontBodyMini,
        'text-[#042040]',
      )}
      onMouseDown={() => setIsDragging(true)}
      onMouseUp={() => setIsDragging(false)}
    >
      {children}
    </div>
  );
};

Offer.Title = Title;
Offer.PriceSection = PriceSection;
Offer.Button = Button;
Offer.FeaturesSections = FeaturesSections;
Offer.Highlighted = Highlighted;
Offer.AnchorLink = AnchorLink;
export default Offer;
